/**
 * 生成一串好念、好抄的初始密码。
 *
 * 字符表和后端 services/api/src/password.ts 里那个一致，但没有共用：
 * contracts 包只放前后端的接口契约，塞一个随机数生成器进去名不副实；
 * 而这一串是在浏览器里生成、直接连着表单提交的，为了拿几个随机数专门跑一趟后端不值得。
 */
const READABLE = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';

/** 拒绝采样：直接取模会让靠前的字符出现得多一些，密码生成器上不该留这种偏差。 */
function pickChars(count: number): string {
  const limit = Math.floor(256 / READABLE.length) * READABLE.length;
  const out: string[] = [];
  const buffer = new Uint8Array(count * 2);

  while (out.length < count) {
    crypto.getRandomValues(buffer);
    for (const byte of buffer) {
      if (byte >= limit) continue;
      out.push(READABLE[byte % READABLE.length]!);
      if (out.length === count) break;
    }
  }

  return out.join('');
}

/** 三组四位，中间短横线。14 个字符，比「至少 12 位」的下限还宽裕。 */
export function generateInitialPassword(): string {
  const chars = pickChars(12);
  return [chars.slice(0, 4), chars.slice(4, 8), chars.slice(8, 12)].join('-');
}
